<div class="fab-container">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'add'">
      <ng-container *ngTemplateOutlet="add"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'toolbar'">
      <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'footer'">
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #add>
  <button [@SwipeAnimator]="animationState"
          (@SwipeAnimator.done)="resetAnimation()"
          mat-fab [disabled]="disabled" (click)="fabClick()">
    <mat-icon>{{ icon }}</mat-icon>
  </button>
</ng-template>

<ng-template #toolbar>
  <div class="fab-container-toolbar" (mouseenter)="toggleOnFab()"
       (mouseleave)="toggleOffFab()">
    <button #fabControl mat-fab class="fixed-action-btn">
      <mat-icon class="large material-icons" [@fabToggler]="{value: fabTogglerState}">keyboard_backspace</mat-icon>
    </button>
    <div class="mini-fabs">
      <button mat-mini-fab (mouseenter)="onMouseEnterAdd()" (mouseleave)="onMouseExitAdd()" (click)="fabAddClick()"
              *ngIf="isMenuOpened"
              class="fab-add-button">
        <mat-icon>add</mat-icon>
      </button>
      <mat-hint *ngIf="hoveredAdd" class="add-hint">{{'general.actions.addNew' | translate}}</mat-hint>
      <button mat-mini-fab (mouseenter)="onMouseEnterChangeView()" (mouseleave)="onMouseExitChangeView()"
              (click)="fabChangeClick()" *ngIf="isMenuOpened"
              class="fab-change-view-mode-button">
        <mat-icon>collections</mat-icon>
      </button>
      <mat-hint *ngIf="hoveredChangeView" class="change-hint">{{('general.actions.changeViewMode') | translate}}</mat-hint>

    </div>
  </div>
</ng-template>

<ng-template #footer>
  <div class="fab-relative-container">
    <button mat-mini-fab [disabled]="disabled" (click)="fabClick()">+</button>
  </div>
</ng-template>
